import { type ReactNode } from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";

import style from "./Tooltip.module.scss";

export type TooltipProps = {
  content: ReactNode;
  children: ReactNode;
  arrowSize?: number;
  className?: string;
  direction?: "top" | "bottom" | "left" | "right";
};

export const Tooltip = ({
  children,
  direction,
  content,
  className,
  arrowSize = 5,
}: TooltipProps) => {
  const tooltipId = crypto.randomUUID();
  return (
    <>
      <ReactTooltip
        arrowSize={arrowSize}
        id={tooltipId}
        className={className || style.content}
      >
        {content}
      </ReactTooltip>
      <div data-tooltip-id={tooltipId} data-tooltip-place={direction}>
        {children}
      </div>
    </>
  );
};
